
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogUserLockErrorPasswordGrid extends Serenity.EntityGrid<LogUserLockErrorPasswordRow, any> {
        protected getColumnsKey() { return LogUserLockErrorPasswordColumns.columnsKey; }
        protected getDialogType() { return LogUserLockErrorPasswordDialog; }
        protected getIdProperty() { return LogUserLockErrorPasswordRow.idProperty; }
        protected getInsertPermission() { return LogUserLockErrorPasswordRow.insertPermission; }
        protected getLocalTextPrefix() { return LogUserLockErrorPasswordRow.localTextPrefix; }
        protected getService() { return LogUserLockErrorPasswordService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: LogUserLockErrorPasswordService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}